<template>
    <v-container>
        <v-card elevation="2">
            <v-card-title class="text-h6">📋 Tickets Registrados</v-card-title>
            <v-data-table :headers="headers" :items="dataTickets" class="elevation-1" :search="search"
                :items-per-page="10" :server-items-length="totalItems" :page.sync="page" :loading="loading"
                @update:page="cargarTickets">
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Tickets</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                            hide-details></v-text-field>
                    </v-toolbar>
                </template>
                <!-- 
                <template v-slot:item.numero="{ item,index }">
                    {{ index+1 }}
                </template>
                -->
                <template v-slot:item.numero="{ item, index }">
                    {{ index + 1 + ((page - 1) * itemsPerPage) }}
                </template>
                <template v-slot:item.estado_actual="{ item }">
                    <el-tag type="success" v-if="item.estado_actual == 'Nuevo'" size="small"
                        class="tag-nuevo">Nuevo</el-tag>
                    <el-tag type="warning" v-if="item.estado_actual == 'Asignado'" size="small">Asignado</el-tag>
                    <el-tag class="tag-proceso" v-if="item.estado_actual == 'En proceso'" size="small">En
                        proceso</el-tag>
                    <el-tag type="teal" v-if="item.estado_actual == 'En espera'" size="small">En espera</el-tag>
                    <el-tag type="success" v-if="item.estado_actual == 'Resuelto'" size="small">Resuelto</el-tag>
                    <el-tag type="danger" v-if="item.estado_actual == 'Cancelado'" size="small">Cancelado</el-tag>
                    <el-tag class="tag-cerrado" v-if="item.estado_actual == 'Cerrado'" size="small">Cerrado</el-tag>
                </template>

                <template v-slot:item.acciones="{ item }">
                    <v-btn color="info" small @click="openEditTicket(item)">Ver</v-btn>
                </template>
            </v-data-table>
            <el-dialog :title="titleFormTicket" :visible.sync="dialogTicket">
                <div v-loading.lock="fullscreenLoading">
                    <el-form :model="usuarioForm" label-position="top" ref="usuarioForm" style="width: 100%;">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <el-form-item label="Incidente" :label-width="formLabelWidth" prop="titulo">
                                    <el-input v-model="ticketSelected.titulo" autocomplete="off" disabled></el-input>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <el-form-item label="Contacto" :label-width="formLabelWidth" prop="celular">
                                    <el-input v-model="ticketSelected.celular" autocomplete="off" disabled></el-input>
                                </el-form-item>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <el-form-item label="Ubicación" :label-width="formLabelWidth" prop="titulo">
                                    <el-input v-model="ticketSelected.area" autocomplete="off" disabled></el-input>

                                </el-form-item>
                            </v-col>
                        </v-row>
                    </el-form>
                    <div style="overflow-y:scroll ;max-height: 17rem !important;padding: 1rem 0 !important;">
                        <el-timeline>
                            <el-timeline-item v-for="(activity, index) in activities" :key="index"
                                :icon="activity.estado_icono" :type="activity.type" color="#0074bd"
                                :size="activity.size" :timestamp="activity.fecha_cambio">
                                {{ activity.estado_nombre }}
                                <p style="color: #787878;margin-bottom: 0 !important;">{{ activity.justificacion }}</p>
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeEditTicket">Cerrar</el-button>
                </span>
            </el-dialog>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
    data() {
        return {
            fullscreenLoading: false,
            formLabelWidth: '70px',
            ticketSelected: [],
            activities: [],
            titleFormTicket: 'Ticket',
            dialogTicket: false,
            search: '',
            tickets: [],
            usuarioForm: {
                estado_actual_id: null,
                usuario_id: null,
                estado_id: null,
                justificacion: null,
                ticket_id: null
            },
            headers: [
                { text: 'N°', value: 'numero' },
                { text: 'Titulo', value: 'titulo' },
                { text: 'Número Ticket', value: 'numero_ticket_formateado' },
                { text: 'Estado', value: 'estado_actual' },
                { text: 'Personal Asignado', value: 'usuario' },
                { text: 'Fecha', value: 'fecha_creacion' },/* 
        { text: '', value: 'icono', sortable: false }, */
                { text: 'Acciones', value: 'acciones', sortable: false },
            ],
            idCliente: null,
            arrayEstados: [],
            itemTicket: null,
            page: 1,
            itemsPerPage: 10,
            totalItems: 0,
            search: '',
            dataTickets: [],
            loading: false,
        }
    },
    created() {
        this.idCliente = sessionStorage.getItem("usuarioIdAyuda");
    },
    mounted() {
        this.cargarTickets()
    },
    methods: {
        openEditTicket(item) {
            this.fullscreenLoading = true;
            this.usuarioForm.estado_id = null;
            this.usuarioForm.justificacion = '';
            this.itemTicket = item;
            this.loadTicketHistorial();
            this.dialogTicket = true;
        },
        closeEditTicket() {
            this.itemTicket = null;
            this.dialogTicket = false;
        },
        loadTicketHistorial() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/mesa_ayuda_tickets/" + this.itemTicket.id + "/historial-estados/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.loadTicketSelected();
                            this.activities = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadTicketSelected() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/mesa_ayuda_tickets/" + this.itemTicket.id + "/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.ticketSelected = res.data;
                            this.fullscreenLoading = false;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        async cargarTickets() {
            this.loading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/mesa_ayuda_tickets/ticket-cliente/?cliente=" + this.idCliente+"&page="+this.page, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.loading = false;
                            this.dataTickets = res.data.results;
                            this.totalItems = res.data.count;
                        })
                        .catch((res) => {
                            this.loading = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.loading = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        getEstadoColor(estado) {
            switch (estado) {
                case 'Abierto': return 'red';
                case 'En Proceso': return 'orange';
                case 'Cerrado': return 'green';
                default: return 'grey';
            }
        },
        getIcono(categoria) {
            const iconos = {
                'Problemas con el Internet': 'mdi-wifi-alert',
                'Problema con la Computadora (PC) e Impresora': 'mdi-monitor',
                'Problema con Software y Programas': 'mdi-floppy',
                'SGD': 'mdi-flash',
                'Teams': 'mdi-microsoft-teams',
                'ESSI y ESSI Extranet': 'mdi-school',
                'HISAR': 'mdi-home',
            };
            return iconos[categoria] || 'mdi-alert-circle';
        },
        verDetalle(ticket) {
            // Puedes navegar a una vista de detalle
            this.$router.push({ name: 'detalle-ticket', params: { id: ticket.id } });
        }
    }
}
</script>

<style scoped>
::v-deep .el-timeline-item__node--normal {
    top: -4px;
    left: -8px;
    width: 25px;
    height: 25px;
}

::v-deep .el-timeline-item__icon {
    color: #FFF;
    font-size: 15px;
}

.v-data-table {
    font-size: 14px;
}

.tag-cerrado.el-tag.el-tag--small {
    background-color: #c7c7c7 !important;
    color: #403d3d;
    border: #403d3d;
}

.tag-nuevo {
    background-color: #f9f2fc;
    color: #8c51a6;
    border: #8c51a6;
}

.tag-proceso {
    background-color: #fcf6f2;
    color: #ff9c59;
    border-color: #ff9c59;
}
</style>